import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { clock } from "@faire/web--source/common/clock";
import differenceInDays from "date-fns/differenceInDays";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { setIntervalIfPossible } from "@faire/retailer/lib/async-functions/setIntervalIfPossible";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { countdownString } from "../utils";
var ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
export var CountdownBannerBase = function(param) {
    var deadline = param.deadline, daysBeforeDeadlineView = param.daysBeforeDeadlineView, hoursBeforeDeadlineView = param.hoursBeforeDeadlineView, loggedOutView = param.loggedOutView, onCountdownChange = param.onCountdownChange;
    var _useState = _sliced_to_array(useState(function() {
        return clock.date();
    }), 2), currentDate = _useState[0], setCurrentDate = _useState[1];
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var deadlineDate = useMemo(function() {
        return new Date(deadline);
    }, [
        deadline
    ]);
    var history = useHistory();
    var latestMarketMainEventRangeDate = useMarketStore([
        "latestMarketMainEventRangeDate"
    ]).latestMarketMainEventRangeDate;
    var daysBeforeDeadline = useMemo(function() {
        return differenceInDays(deadlineDate, currentDate);
    }, [
        currentDate,
        deadlineDate
    ]);
    var showHourCountdown = daysBeforeDeadline <= 0;
    useEffect(function() {
        return onCountdownChange();
    }, [
        currentDate,
        deadlineDate,
        onCountdownChange
    ]);
    useEffect(function() {
        var interval = setIntervalIfPossible(function() {
            return setCurrentDate(clock.date());
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    if (!isLoggedInRetailer && loggedOutView) {
        return loggedOutView(showHourCountdown, latestMarketMainEventRangeDate, history);
    }
    if (showHourCountdown) {
        return hoursBeforeDeadlineView(countdownString(deadlineDate, currentDate));
    }
    return daysBeforeDeadlineView(daysBeforeDeadline, countdownString(deadlineDate, new Date(currentDate.getTime() + daysBeforeDeadline * ONE_DAY_IN_MS)), latestMarketMainEventRangeDate);
};
